<template>
  <div class="kehu">
    <div class="headerKehu">
      <div class="datas">
        <span class="datas_num">{{ numberViewsToday.toDayNum }}</span>
        <p class="datas_numtext">今日查看人数</p>
      </div>
      <div class="datas">
        <span class="datas_num">{{ numberViewsToday.totalPeopleNum }}</span>
        <p class="datas_numtext">总人数</p>
      </div>
      <div class="datas">
        <span class="datas_num">{{ numberViewsToday.totalNumView }}</span>
        <p class="datas_numtext">总次数</p>
      </div>
      <!-- <div class="datas" @click="gopage('tixing')">
        <span class="datas_btn">立即提醒</span>
        <p class="datas_btntext">提醒设置</p>
      </div> -->
    </div>
    <div style="height: 1.5rem;"></div>
    <div class="kehulist">
      <div class="kehuli" v-for="(item, index) in clientList" :key="index">
        <div
          class="liHead"
          @click="gouserinfo(item.uid, item.nickname, item.avatar)"
        >
          <img :src="item.avatar" />
        </div>
        <div
          class="liText"
          @click="gouserinfo(item.uid, item.nickname, item.avatar)"
        >
          <div>{{ item.nickname }}</div>
          <p>{{ item.add_time }}</p>
        </div>
        <span
          class="lookNum tag-read"
          @click="copy"
          :data-clipboard-text="item.nickname"
          >复制微信名<i style="opacity: 0;display: block;width: 0;height: 0;">{{
            item.nickname
          }}</i></span
        >
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <div class="mengcengDialog" v-if="quanxainDialog">
      <div class="content_mc">
        <div class="mcText1">
          你已错过多次跟进机会<br />有多少机会可以继续错过
        </div>
        <div class="mcText2">
          <router-link :to="{ path: '/member' }">
            立即跟进客户
          </router-link>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <div class="nodata" v-if="nodataDialog">
      <img src="../../../assets/images/nodata.png" />
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import "@assets/css/kehu.css";
import { Toast } from "vant";
import {
  getShare,
  getClientListNew,
  getNumberViewsTodayNew,
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "kehuList",
  components: {},
  props: {},
  data: function() {
    return {
      quanxainDialog: false,
      nodataDialog: false,
      numberViewsToday: {},
      clientList: [],
      page: 1,
      isaddmore: true,
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    vm.setOpenShare();
    vm.getNumberViewsTodayNew();
    vm.getClientListNew();
    window.addEventListener("scroll", this.scrollBottom);
  },
  methods: {
    getNumberViewsTodayNew() {
      getNumberViewsTodayNew().then((res) => {
        this.numberViewsToday = res.data;
      });
    },
    // 获取客户线索列表
    getClientListNew() {
      if (this.isaddmore) {
        this.isaddmore = false;
        var data = "?limit=20&page=" + this.page;
        getClientListNew(data)
          .then((res) => {
            this.quanxainDialog = false;
            this.nodataDialog = false;
            console.log("成功：", res);
            if (res.data.data.length < 1) {
              this.isaddmore = false;
            } else {
              this.clientList = this.clientList.concat(res.data.data);
              if (res.data.data.length < 20 && res.data.data.length > 0) {
                this.isaddmore = false;
              } else {
                this.isaddmore = true;
              }
            }
          })
          .catch((err) => {
            console.log("err:", err);
            if (err.msg == "暂无数据！") {
              this.quanxainDialog = false;
              this.nodataDialog = true;
            } else {
              this.nodataDialog = false;
              this.quanxainDialog = true;
            }
          });
      }
    },
    gouserinfo(id, name, avatar) {
      return this.$router.push({
        path: "/kehu/kehuinfo",
        query: { id: id, name: name, avatar: avatar },
      });
    },
    //跳转
    gopage(type) {
      if (type == "tixing") {
        console.log(1);
        return this.$router.push({ path: "/kehu/setMessageReminder" });
      }
    },
    scrollBottom() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 80;
      console.log(scrollHeight);
      if (scrollTop != 0 && bottomOfWindow && this.isaddmore == true) {
        this.page = this.page + 1;
        this.getClientListNew();
      }
    },
    copy() {
      var clipboard = new this.Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jiaojiao.yanjiusuo.xyz",
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
  },
};
</script>

<style>
.nodata {
  position: absolute;
  top: 30%;
  width: 100%;
  left: 0;
  text-align: center;
}
.nodata img {
  display: block;
  width: 4rem;
  margin: 0 auto;
}
.nodata p {
  font-size: 0.26rem;
  margin-top: 0.02rem auto 0;
  color: #666;
  text-align: center;
}
</style>
